import cn from 'classnames';
import { FC } from 'react';

import styles from './ConditionUserScoreInput.module.scss';

type ConditionUserScoreInputProps = {
  className?: string;
  value?: number;
  error?: boolean;
  disabled?: boolean;
  onChange: (value: number | undefined) => void;
};

export const ConditionUserScoreInput: FC<ConditionUserScoreInputProps> = (
  props,
) => {
  const { className, value, error, disabled, onChange } = props;

  const handleChange = (rawValue: string) => {
    if (rawValue === '') {
      onChange(undefined);

      return;
    }

    const parsedValue = Math.min(100, Math.max(0, Number(rawValue)));

    onChange(Number.isNaN(parsedValue) ? undefined : parsedValue);
  };

  return (
    <div
      className={cn(styles.container, className)}
      data-component="condition-score-input"
    >
      <input
        type="number"
        min="0"
        max="100"
        value={value !== undefined ? value : ''}
        disabled={disabled}
        onChange={(event) => handleChange(event.target.value)}
        placeholder="___"
        className={cn(styles.input, 'h7', error && styles.inputError)}
      />
      <span className={styles.percent}>%</span>
    </div>
  );
};
